import React from 'react'
import { Button, Col, Row,FormControl, Spinner } from 'react-bootstrap';
import firebase from 'gatsby-plugin-firebase'

const Login = () => {

    const [email, setEmail ] = React.useState('')
    const [password, setPassword] = React.useState('')
    const [loader, showLoader] = React.useState('none')
    const [warning, showWarning] = React.useState('none')
    const [warningText, setWarningText] = React.useState("")
    const db = firebase.firestore()

    const saveSettings = (data) => {
                  const cities = data.cities
                  const settings = data.settings
                  if(cities){
                      localStorage.setItem("weatherAppLocations", JSON.stringify(cities))
                  }

                 try{
                    if(settings.showArrows) {
                        localStorage.setItem("showArrows", JSON.stringify(settings.showArrows))
                    }
                 } catch {
                     // Just ignore if sattings are not saved in database
                 }
                 try {
                    if(settings.weatherDetails) {
                        localStorage.setItem("weatherDetails", JSON.stringify(settings.weatherDetails))
                    }
                 } catch {}
                 try {
                    if(settings.theme) {
                        localStorage.setItem("theme", JSON.stringify(settings.theme))
                    }
                 } catch{}
                               
    }
    const handleLogin = async() => {
        if(email =='' || password == '') {
            setWarningText("Please Enter valid information")
            showWarning("block")
            return
        }
        showLoader('block')
        firebase.auth()
        .signInWithEmailAndPassword(email, password)
        .then( async(creds) => {
            const appUser = {
                email : creds.user.email,
                displayName : creds.user.displayName,
                photoURL : creds.user.photoURL,
                uid : creds.user.uid
            }
            const userRef = firebase.firestore().collection('users').doc(creds.user.uid);
            const doc = await userRef.get();
            const data = doc.data()
            if (doc.exists) {
                if(data.membership.isPremium) {
                    saveSettings(data)  
                }
            } 
            localStorage.setItem("AppUser", JSON.stringify({
                ...appUser,
                membershipId : data.membership.customerId | "",
                isActive : data.membership.isPremium | false
            }))
            showLoader('none')
            window.location.reload();
            
        }) 
        .catch(err => {
            showLoader('none')
            setWarningText(`${err}`)
            showWarning("block")
        })
    }
    const  handleGoogleSignIn = async() =>  {
        let provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope("https://www.googleapis.com/auth/userinfo.profile")
        firebase.auth().signInWithPopup(provider).then( async(creds) => {
            const appUser = {
                email : creds.user.email,
                displayName : creds.user.displayName,
                photoURL : creds.user.photoURL,
                uid : creds.user.uid
            }
            const userRef = firebase.firestore().collection('users').doc(creds.user.uid);
            const doc = await userRef.get();
            const data = doc.data()
            if (doc.exists) {
                if(data.membership.isPremium) {
                    saveSettings(data)  
                }
                localStorage.setItem("AppUser", JSON.stringify({
                    ...appUser,
                    membershipId : data.membership.customerId,
                    isActive :  data.membership.isPremium 
                }))
            }
            else {
                localStorage.setItem("AppUser", JSON.stringify({
                    ...appUser,
                    membershipId : "",
                    isActive :  false 
                })) 
            } 
            showLoader('none')
             window.location.reload();  
        })
}

const handleFacebookSignIn = () => {
        var provider = new firebase.auth.FacebookAuthProvider();
        provider.setCustomParameters({
            'display': 'popup'
        })
        firebase.auth().signInWithPopup(provider).then(async creds => {
           const appUser = {
                    email : creds.user.email,
                    displayName : creds.user.displayName,
                    photoURL : creds.user.photoURL,
                    uid : creds.user.uid
                }
                const userRef = firebase.firestore().collection('users').doc(creds.user.uid);
                const doc = await userRef.get();
                const data = doc.data()
                if (doc.exists) {
                    if(data.membership.isPremium) {
                        saveSettings(data)  
                    }
                    localStorage.setItem("AppUser", JSON.stringify({
                        ...appUser,
                        membershipId : data.membership.customerId,
                        isActive :  data.membership.isPremium 
                    }))
                }
                else {
                    localStorage.setItem("AppUser", JSON.stringify({
                        ...appUser,
                        membershipId : "",
                        isActive :  false 
                    })) 
                }
                showLoader('none')
                 window.location.reload();
                
            })
            .catch(error => {
                 setWarningText(`${error.message}`)
                 showWarning("block")
            })
}

return(
<>
    <div>
        <h2>Login</h2>
        <FormControl className="mb-3"
            placeholder="Enter Email"
            aria-label="Email"
            aria-describedby="basic-addon2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
        />
        <FormControl className="mb-3"
            placeholder="Enter Password"
            aria-label="Password"
            aria-describedby="basic-addon1"
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
        />
        <Button className="mb-3" variant="primary" onClick={() => handleLogin()} >
            LOGIN
        </Button>
    </div>
    <span>OR</span>
    <Row xs={12} className="setting fade-in">
        <Col xs={6}>
            <Button variant="primary" onClick={() => handleFacebookSignIn()}>Facebook</Button>
        </Col>
        <Col xs={6}>
            <Button variant="danger" onClick={() => handleGoogleSignIn()}> Google</Button>
        </Col>
    </Row>
    <div style={{
        backgroundColor: '#000',
        opacity : 0.4,
        zIndex : 999,
        justifyContent : 'center',
        flexDirection : 'column',
        alignItems :"center",
        position: 'absolute',
        display : loader,
        paddingTop : 75,
        top:0,bottom:0,left:0,right:0
    }}>
        <Spinner animation="border" variant="success" />
    </div>
    <div style={{
        backgroundColor: '#000',
        opacity : 0.93,
        zIndex : 999,
        justifyContent : 'center',
        flexDirection : 'column',
        alignItems :"center",
        position: 'absolute',
        display : warning,
        paddingTop : 75,
        top:0,bottom:0,left:0,right:0,
        padding : '20px',
        paddingTop : '80px'
    }}>
       <p style={{color:'#fff'}}> {warningText}</p>
       <br/><br/>
       <Button onClick={() => {
           showWarning('none')
           setWarningText("")
           }} variant="primary">OK</Button>
    </div>
</>
    )
}

        export default Login